import React, { useState } from 'react';
import { Button, Input, Layout } from 'antd';
import './App.css';
import MetricTree from './MetricTree';
const { Content } = Layout;
const { TextArea } = Input;

const App = () => {
  const [inputValue, setInputValue] = useState('');
  const [metricTreeValue, setMetricTreeValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  }

  const handleSubmit = () => {
    console.log('Submit');
    setMetricTreeValue(inputValue);
  }

  return (
    <div className="App" >
      <Layout>
        <Content style={{height: '750px'}}>
          <TextArea placeholder="Input" style={{height: '300px'}} onChange={handleInputChange} value={inputValue} />
          <Button type="primary" onClick={handleSubmit} >Submit</Button>
          <MetricTree inputValue={metricTreeValue} expandAll={true}/>
        </Content>
      </Layout>
    </div>
  );
}

export default App;

